module.exports = __webpack_public_path__ + "static/media/person.f6f0e617.svg";